import React from 'react';
// import { useNavigate, useParams } from 'react-router-dom';
import { DownloadIcon } from '@phosphor-icons/react';

export default function CompanyMappingToolbar({
    ideas = [],
    // onAddManual,
    onExport
}) {
    // const navigate = useNavigate();
    // const { conversationId } = useParams();

    // const handlePresentation = () => {
    //     if (ideas.length === 0) return;
    //     navigate(`/tools/company-mapping/${conversationId}/presentation`);
    // };

    const handleExport = () => {
        if (ideas.length === 0) return;
        onExport?.();
    };

    return (
        <div className="w-full flex items-end justify-end gap-3 mb-6">
            {/* <button
                onClick={handlePresentation}
                disabled={ideas.length === 0}
                className={`flex items-center gap-2 px-4 py-2.5 rounded-xl border transition-colors ${
                    ideas.length > 0
                        ? 'border-black/10 hover:bg-black/5 text-black/70 hover:text-black'
                        : 'border-black/5 text-black/30 cursor-not-allowed'
                }`}
            >
                <PresentationChart size={18} weight="bold" />
                <span className="text-sm font-medium">Presenta</span>
            </button> */}

            <button
                onClick={handleExport}
                disabled={ideas.length === 0}
                className={`flex items-center gap-2 px-4 py-2.5 rounded-xl border transition-colors ${
                    ideas.length > 0
                        ? 'border-black/10 hover:bg-black/5 text-black/70 hover:text-black'
                        : 'border-black/5 text-black/30 cursor-not-allowed'
                }`}
            >
                <DownloadIcon size={18} weight="bold" />
                <span className="text-sm font-medium">Esporta</span>
            </button>

            {/* <button
                onClick={onAddManual}
                className="flex items-center gap-2 px-4 py-2.5 rounded-xl bg-black text-white hover:bg-black/90 transition-colors"
            >
                <PlusIcon size={18} weight="bold" />
                <span className="text-sm font-medium">Aggiungi Manualmente</span>
            </button> */}
        </div>
    );
}
